import "./homeLinkCTA.css";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import StarIcon from "@mui/icons-material/Star";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import VerifiedIcon from "@mui/icons-material/Verified";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const testimonials = [
  {
    quote:
      "Universe Inventory gave us a much clearer view of what was happening across our business. We spend less time checking stock manually and more time serving customers and growing the business.",
    name: "Sarah M.",
    role: "Retail Business Owner",
    initials: "SM",
    metric: "Less manual work",
  },
  {
    quote:
      "Managing inventory across multiple locations used to feel complicated. Now our team can see stock movement, sales, and operational activity from one centralized platform.",
    name: "Michael A.",
    role: "Operations Manager",
    initials: "MA",
    metric: "Multi-location visibility",
  },
  {
    quote:
      "The biggest difference is the visibility. We know what we have, where it is, and what needs attention without jumping between different systems.",
    name: "David K.",
    role: "Business Director",
    initials: "DK",
    metric: "Real-time visibility",
  },
];


const HomeLinkCTA = () => {
  return (
    <section className="homeLinkCTA">

      {/* =====================================================
          BACKGROUND
      ====================================================== */}

      <div className="homeLinkCTAGlow homeLinkCTAGlowOne"></div>
      <div className="homeLinkCTAGlow homeLinkCTAGlowTwo"></div>


      {/* =====================================================
          HEADER
      ====================================================== */}

      <div className="homeLinkCTAHeader">

        <div className="homeLinkCTAHeaderBadge fx-ac space1">
          <span className="homeLinkCTABadge"></span>
          <span>Trusted by growing businesses</span>
        </div>

        <h2>
          Built for the businesses
          <span> moving forward.</span>
        </h2>

        <p>
          From the first transaction to your next location,
          Universe Inventory gives your team the visibility,
          control, and confidence to operate better.
        </p>

      </div>


      {/* =====================================================
          TESTIMONIAL AREA
      ====================================================== */}

      <div className="homeLinkCTAMain">

        <Swiper
          className="homeLinkCTASwiper"
          modules={[Autoplay, Navigation, Pagination]}
          slidesPerView={1}
          loop={true}
          speed={800}
          autoplay={{
            delay: 6500,
            disableOnInteraction: false,
          }}
          navigation={{
            prevEl: ".homeLinkCTANav.left",
            nextEl: ".homeLinkCTANav.right",
          }}
          pagination={{
            clickable: true,
            el: ".homeLinkCTAPagination",
          }}
        >

          {testimonials.map((testimonial, index) => (

            <SwiperSlide key={index}>

              <article className="homeLinkCTACard">

                {/* =================================================
                    QUOTE
                ================================================== */}

                <div className="homeLinkCTAQuoteBox">

                  <FormatQuoteIcon />

                </div>


                {/* =================================================
                    TESTIMONIAL
                ================================================== */}

                <div className="homeLinkCTATestimonial">

                  <div className="homeLinkCTAStars fx-ac">

                    {[1, 2, 3, 4, 5].map((star) => (
                      <StarIcon key={star} />
                    ))}

                    <span>
                      5.0
                    </span>

                  </div>


                  <blockquote>
                    “{testimonial.quote}”
                  </blockquote>


                  <div className="homeLinkCTAMetric fx-ac space1">

                    <TrendingUpIcon />

                    <span>
                      {testimonial.metric}
                    </span>

                  </div>

                </div>


                {/* =================================================
                    AUTHOR
                ================================================== */}

                <div className="homeLinkCTAAuthor">

                  <div className="homeLinkCTAAvatar">
                    {testimonial.initials}
                  </div>

                  <div className="homeLinkCTAAuthorInfo">

                    <div className="fx-ac space1">

                      <h4>
                        {testimonial.name}
                      </h4>

                      <VerifiedIcon />

                    </div>

                    <p>
                      {testimonial.role}
                    </p>

                  </div>

                </div>

              </article>

            </SwiperSlide>

          ))}

        </Swiper>


        {/* =====================================================
            NAVIGATION
        ====================================================== */}

        <button
          className="homeLinkCTANav left"
          aria-label="Previous testimonial"
        >
          <ChevronLeftIcon />
        </button>

        <button
          className="homeLinkCTANav right"
          aria-label="Next testimonial"
        >
          <ArrowForwardIcon />
        </button>

      </div>


      {/* =====================================================
          BOTTOM CONVERSION AREA
      ====================================================== */}

      <div className="homeLinkCTAFooter">

        <div className="homeLinkCTAFooterText">

          <span className="homeLinkCTAOverline">
            READY WHEN YOU ARE
          </span>

          <h3>
            Your business is ready
            for a smarter way to operate.
          </h3>

        </div>


        <div className="homeLinkCTAFooterAction">

          <button className="homeLinkCTAButton">

            <span>
              Get Started
            </span>

            <span className="homeLinkCTAButtonIcon">
              <ArrowForwardIcon />
            </span>

          </button>

          <p>
            Start building a more connected operation today.
          </p>

        </div>

      </div>


      {/* =====================================================
          PAGINATION
      ====================================================== */}

      <div className="homeLinkCTAPagination"></div>

    </section>
  );
};


export default HomeLinkCTA;